import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RasterDto } from 'src/app/server-api/models';
import { RasterControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { IRasterFormGroup } from '../raster/IRasterFormGroup';
import { Coordinate, createStringXY } from 'ol/coordinate';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';

interface RasterDetail {
  depth: number;
  rasterName: string;
}

@Component({
  selector: 'app-raster-depth',
  templateUrl: './raster-depth.component.html',
  styleUrls: ['./raster-depth.component.css']
})


export class RasterDepthComponent extends DetailComponent {
  raster: RasterDto;
    
  //override the id coming from route params by id coming from dialog
  @Input() override id: string;
  @Input() x: number;
  @Input() y: number;
  @Input() rasterIds: string;
  //for now not used, can be triggered by this.closeDialogEvent.emit(true);
  @Output() closeDialogEvent = new EventEmitter<boolean>();;
  
  dataArrayDepths = new MatTableDataSource<any>();
  details: RasterDetail[] = [];
  coordinatesFormatted: string;
  displayedColumns: string[];
  headerStyle: string;
  finished: boolean = false;

  constructor(
    public override translate: TranslateService,
    private rasterService: RasterControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    super(translate, sidenavService, router);
  }

  override ngOnInit()
  {
    this.displayedColumns = [ 'rasterName', 'depth'];
    this.headerStyle = "background: " + environment.main_color + ";color:white;";
    
    super.ngOnInit();
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.raster = {} as any as RasterDto;

    this.initForm();
    this.columnsVisible.set('x', true);
    this.columnsVisible.set('y', true);
  }

  override getItem(request) {
    let stringifyFunc = createStringXY(4);
    this.coordinatesFormatted = stringifyFunc([this.x, this.y]);
    
    super.getItem(request);

    this.dataArrayDepths.data.splice(0);
    this.details.splice(0);
    let ids = JSON.parse(this.rasterIds);
    let done = 0;
    ids.forEach((rasterId: string, index: number) => {
      this.rasterService.getValueForRaster({ id: rasterId, x: this.x, y: this.y }).subscribe((body) => {
        if (body)
        {
          this.rasterService.getRaster({id: rasterId}).subscribe((r) => 
          {
            let name = r.temporary ? r.originalFileName : r.category.name;
            let detail = { depth: body, rasterName: name } as RasterDetail;
            this.details.push(detail);  
            done++;
            if (done === ids.length) 
            {
              this.initForm();   
            }            
          }
          );
        }  
      },
      () => {
        this.sidenavService.setLoading(false);
       done++;
       if (done === ids.length) 
       {
        this.initForm();   
       }   
      });
    }
    );
    
  }
    
  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    this.columnsVisible = new Map([
      ['x', true],
      ['y', true]
    ]);

    this.detailForm = this.formBuilder.group({
      x: [{value: '', disabled: true}],
      y: [{value: '', disabled: true}]  
    }) as IRasterFormGroup;
  
    this.detailForm.controls['x'].patchValue(this.x.toFixed(4));
    this.detailForm.controls['y'].patchValue(this.y.toFixed(4));
    this.finished = true;
  }

  override initForm() {
    this.dataArrayDepths.data = this.details;
    super.initForm();
    
    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu']).subscribe((translations: string) => {
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
        }
      ];
    });
    this.setForm();
  }

  
  override saveOk() {
    super.saveOk();
    this.sidenavService.setLoading(false);
    //no save done
  }


  override delete() {
    super.delete();
    this.sidenavService.setLoading(false);
    //no delete done
  }
}

  
